import type { AuthProviderUpdateRequest } from "@/app/oauth/types";
import type { ApiClient } from "@/lib/api";

export async function updateOAuthProvider(options: {
  client: ApiClient;
  oauthId: string;
  oauthProvider: AuthProviderUpdateRequest;
}) {
  const { client, oauthId, oauthProvider } = options;

  const payload = {
    // biome-ignore lint/plugin/no-type-assertion: existing type assertion; prefer type guards for new code
    ...(oauthProvider as unknown as Record<string, unknown>),
  };
  // biome-ignore lint/plugin/no-type-assertion: existing type assertion; prefer type guards for new code
  (payload as Record<string, unknown>).binding = undefined;

  const { data } = await client.patch<AuthProviderUpdateRequest>(
    `/auth_providers/${oauthId}`,
    // biome-ignore lint/plugin/no-type-assertion: existing type assertion; prefer type guards for new code
    payload as AuthProviderUpdateRequest
  );
  return data;
}
